// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import { InView } from 'react-intersection-observer';
import PropTypes from 'prop-types';

import 'app/shared/modules/hdp/HdpForm.scss';
import Contact from 'app/shared/modules/hdp/form/Contact/Contact';
import { emitTrackInlineContactFormViewEvent } from 'app/shared/models/Clickstream/ContactClickstreamEvents';

const { object, func, array } = PropTypes;

class HdpForm extends React.Component {
  static propTypes = {
    listing: object.isRequired,
    similarListings: array,
    onShowSuccessModal: func,
  };

  static defaultProps = {
    similarListings: [],
    onShowSuccessModal() {},
  };

  constructor(props) {
    super(props);
  }

  handleScrollToBottom = () => {
    emitTrackInlineContactFormViewEvent({ listing: this.props.listing });
  };

  render() {
    const { listing, similarListings, onShowSuccessModal } = this.props;

    return (
      <div className="HdpForm" id="HdpForm">
        <Contact listing={listing} similarListings={similarListings} onShowSuccessModal={onShowSuccessModal} />
        {/* Handles GA tracking when user scrolls and HDP form comes into view */}
        <InView
          as="span"
          triggerOnce
          onChange={(inView) => {
            if (inView) {
              this.handleScrollToBottom();
            }
          }}
        />
      </div>
    );
  }
}

export default connect()(HdpForm);
